var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFbCorner = function SvgFbCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 83 79"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb-corner_svg__a)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C76BE",
    d: "M56.973 7.321 16.777 25.218a17.925 17.925 0 0 0-9.123 23.765l17.897 40.196A17.925 17.925 0 0 0 49.316 98.3l40.196-17.896a17.925 17.925 0 0 0 9.122-23.765L80.738 16.444A17.925 17.925 0 0 0 56.973 7.32Zm.653 27.897-.457.203-3.883 1.729c-1.827.813-2.435 1.905-1.748 4.062l2.237 5.025 7.08-3.153 2.238 7.487-6.166 2.746 8.033 18.042-7.308 3.254-8.034-18.042-6.166 2.745-3.152-7.08 6.166-2.745-.203-.457-1.932-4.34c-.407-.913-.814-1.827-.992-2.842-.687-2.157-.232-4.823.859-6.676 1.192-1.626 2.384-3.251 4.44-4.166l3.882-1.729c.685-.305 1.472-.381 2.157-.687l2.949 6.624Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fb-corner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 32.54 73.417 0l32.539 73.084-73.084 32.539z"
  })))));
};
export default SvgFbCorner;